import { useSubscriptionInitialData, useCurrentUser } from '@shared/hooks';
import { getSubscriptionsData, saveSubscriptions } from '@api/onboarding';
import { ResponseErrorDto, OnboardingStep } from '@interfaces/models';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '@shared/enums';
import { toast } from '@ui/components';

export const useOnboardingSubscriptions = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: initialData, isLoading: isInitialDataLoading } = useSubscriptionInitialData({
    companyType: user?.companies[0]?.companyType,
  });

  const onSubmit = (id: string): void => {
    sendRegisterMutation.mutate(id);
  };

  const sendRegisterMutation = useMutation({
    mutationFn: (id: string) => {
      return saveSubscriptions({
        nextStep: OnboardingStep.COMPANY_POLICY,
        subscriptionCode: id,
      });
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      toast.error(t(`API_ERRORS.${error.errorCode}`));
    },
    onSuccess: () => {
      navigate(`../${Routes.COMPANY_POLICY}`);
    },
  });

  const { data: subscriptionsData, isLoading: isQueryLoading } = useQuery({
    queryKey: ['onboarding', 'subscriptions'],
    queryFn: getSubscriptionsData,
  });

  const isMutationLoading = sendRegisterMutation.isPending;

  return {
    isInitialDataLoading,
    subscriptionsData,
    isMutationLoading,
    isQueryLoading,
    initialData,
    onSubmit,
  };
};
